module.exports = __webpack_public_path__ + "img/sejour.7609e911.svg";